// import
import SalaryFormat from "./SalaryFormat";
import TimestampFormat from './TimestampFormat';
import limitWords from './limitWords';
import Vue from 'vue';

// 组件
const components = {
  SalaryFormat,
  TimestampFormat,
  limitWords
};

// 定义全局组件
Object.keys(components).forEach(key => Vue.filter(key,components[key]));


// WEBPACK FOOTER //
// ./src/filters/main.js